module.exports = __webpack_public_path__ + "img/a.77637b67.jpg";